import { render, staticRenderFns } from "./GodDetail.vue?vue&type=template&id=597b6c44&scoped=true&"
import script from "./GodDetail.vue?vue&type=script&lang=js&"
export * from "./GodDetail.vue?vue&type=script&lang=js&"
import style0 from "./GodDetail.vue?vue&type=style&index=0&id=597b6c44&lang=less&"
import style1 from "./GodDetail.vue?vue&type=style&index=1&id=597b6c44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597b6c44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('597b6c44')) {
      api.createRecord('597b6c44', component.options)
    } else {
      api.reload('597b6c44', component.options)
    }
    module.hot.accept("./GodDetail.vue?vue&type=template&id=597b6c44&scoped=true&", function () {
      api.rerender('597b6c44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/god/comp/GodDetail.vue"
export default component.exports